var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C3C",
    d: "M9.752 0C4.375 0 0 4.375 0 9.752c0 5.378 4.375 9.753 9.752 9.753 5.378 0 9.753-4.375 9.753-9.753C19.505 4.375 15.13 0 9.752 0zm3.945 12.548c.159.158.159.416 0 .574l-.575.575c-.158.158-.416.158-.574 0l-2.796-2.795-2.795 2.795c-.159.158-.416.158-.575 0l-.574-.575c-.159-.158-.159-.416 0-.574l2.795-2.796-2.795-2.795c-.159-.159-.159-.416 0-.575l.574-.574c.16-.159.416-.159.575 0l2.795 2.795 2.796-2.795c.158-.159.416-.159.574 0l.575.574c.159.16.159.416 0 .575l-2.795 2.795 2.795 2.796z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/closeButton.3d60c444a3e22ddb61e7a4b29a998e40.svg";
export { ForwardRef as ReactComponent };